import '../../../style/header-sortable.scss'
import sortNormal from '@/public/assets/images/sort-normal.svg'
import sortUp from '@/public/assets/images/sort-up.svg'
import sortDown from '@/public/assets/images/sort-down.svg'

const sortImg = {
  ascending: sortUp,
  descending: sortDown,
  default: sortNormal
}

export function createSortable() {
  return {
    functional: true,
    render(h, context) {
      const type = context.props.sortOrder || 'default'
      const imgUrl = sortImg[type]
      return (
        <span class="header-sortable-wrapper">
          <img
            src={imgUrl}
            class={['sort-caret', context.props.sortOrder]}
            on-click={event => {
              event.stopPropagation()
              context.props.handleSortChange()
            }}></img>
        </span>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/feature/sortable/index.js